import { useEffect, useState } from 'react';
import { getServerUrl } from '../../universal-nav/utils/getServerUrl';
import { isEmptyObject } from '../../universal-nav/utils/isEmptyObject';
import { useUniversalNavContext } from '../../universal-nav/hooks';

// Possible treatments for the all sales final AlertBanner feature
export type SplitTreatment = 'on' | 'off' | 'prelaunch';

type useAllSalesFinalTreatmentReturn = {
  isLoading: boolean;
  treatment: SplitTreatment;
};

// Coda brief: https://coda.io/d/Team-Payments_dPgPHC1Ds0u/Policy-Change_su5Mr#_luNby
export const useAllSalesFinalTreatment = (
  accountId?: string | number
): useAllSalesFinalTreatmentReturn => {
  const [isLoading, setIsLoading] = useState(true);
  const [treatment, setTreatment] = useState<SplitTreatment>('off');

  const { bffHostname } = useUniversalNavContext();

  useEffect(() => {
    const serverUrl = getServerUrl(bffHostname);
    const allSalesFinalTreatmentUrl = `${serverUrl}/all-sales-final/treatment`;

    async function getSplitData() {
      try {
        setIsLoading(true);

        const response = await fetch(allSalesFinalTreatmentUrl, {
          headers: { 'x-account-id': accountId?.toString() ?? '0' },
        });

        if (!response.ok) {
          throw new Error('Response was not OK');
        }

        const json = await response.json();
        const { data } = json;
        if (!isEmptyObject(data)) setTreatment(data);
      } catch (error) {
        // Default to off if there's an error
        setTreatment('off');
      } finally {
        setIsLoading(false);
      }
    }

    if (accountId) getSplitData();
  }, [accountId, bffHostname]);

  return { isLoading, treatment };
};
